import React from 'react';

import { View } from 'react-native';

import { NowIndicator } from 'assets/images';

import { PROGRAM_GRID_NOW } from 'config/testID';

import styles from './styles';

type Props = {
    visible: boolean;
};

export default function EpgNowLine({ visible }: Props) {
    if (visible) {
        return (
            <View testID={PROGRAM_GRID_NOW} style={styles.container}>
                <NowIndicator />
                <View style={styles.verticalBar} />
            </View>
        );
    }

    return null;
}
